module.exports = __webpack_public_path__ + "img/impala-19.254bfbb0.png";